import { makeRequestGet } from "../../../../../Services/API";

export function getAcessoriosArtigo(itmref, lang) {
  return makeRequestGet(
    `/backend/catalogo/Acessorios/${lang}?itmref=${itmref}`
  );
}
